import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const ExpenseView = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Http.get(`/accounts/expenses/${id}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Expense Details</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Expense Information</h6>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <tbody>
                    <tr>
                      <th width="200">Date</th>
                      <td>{new Date(data.date).toLocaleDateString()}</td>
                    </tr>
                    <tr>
                      <th>Category</th>
                      <td>{data.category?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Amount</th>
                      <td>{data.amount}</td>
                    </tr>
                    <tr>
                      <th>Reference</th>
                      <td>{data.reference || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>{data.description || "N/A"}</td>
                    </tr>
                    {/* <tr>
                      <th>Status</th>
                      <td>
                        {data.status === "active" ? (
                          <span className="badge badge-success">Active</span>
                        ) : (
                          <span className="badge badge-danger">Inactive</span>
                        )}
                      </td>
                    </tr> */}
                    <tr>
                      <th>Created At</th>
                      <td>{new Date(data.created_at).toLocaleString()}</td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>{new Date(data.updated_at).toLocaleString()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseView;